const _apiPrefix: string = process.env.REACT_APP_API_PREFIX ?? "/api/v1";
const _apiHostUrl: string =
	process.env.REACT_APP_API_HOST_URL ?? "http://127.0.0.1:5001";

export const serviceConfig = {
	apiHost: _apiHostUrl,
	apiUrl: `${_apiHostUrl}${_apiPrefix}`,
	useMockApi: process.env.REACT_APP_USE_MOCK_API
		? parseInt(process.env.REACT_APP_USE_MOCK_API)
		: 1,

	websocket_port:
		process.env.REACT_APP_WEBSOCKET_PORT ?? "http://127.0.0.1:5003",
	digidocs_template: process.env.REACT_APP_DIGIDOCS_TEMPLATE
		? parseInt(process.env.REACT_APP_DIGIDOCS_TEMPLATE)
		: 1,

	routes: {
		all_sliders:
			process.env.REACT_APP_API_ALL_SLIDERS_ROUTE ?? "/tbl-dk-sliders/",
	},
};
